import { IColunasSettingsUser } from '@app/shared/utils/validar_settings_user';

export const COLUNAS_DEFAULT_MODULE_PARAMETRIZACAO = [
  {
    module: 'TAG',
    colunas: [
      {
        field: 'nome',
        active: true,
        removable: false
      },
      {
        field: 'descricao',
        active: true,
        removable: true
      }
    ]
  },
  {
    module: 'ENCARTE_PROMOCAO',
    colunas: [
      {
        active: true,
        removable: true,
        field: 'numero'
      },
      {
        active: true,
        removable: false,
        field: 'nome'
      },
      {
        active: true,
        removable: true,
        field: 'data_inicio'
      },
      {
        active: true,
        removable: true,
        field: 'data_fim'
      },
      {
        active: true,
        removable: true,
        field: 'status'
      }
    ]
  },
  {
    module: 'REPORT_VENDAS',
    colunas: [
      { field: 'pedido.data_hora', active: true, removable: true },
      {
        field: 'pedido.cliente.parceiro.cpf_cnpj',
        active: true,
        removable: true
      },
      {
        field: 'pedido.cliente.parceiro.nome_razao_social',
        active: true,
        removable: false
      },
      { field: 'pedido.valor_bruto', active: true, removable: true },
      { field: 'pedido.valor_desconto', active: true, removable: true },
      { field: 'pedido.valor_acrescimo', active: true, removable: true },
      { field: 'pedido.valor_total', active: true, removable: true },
      { field: 'condicao_pagamento.descricao', active: true, removable: true },
      { field: 'status', active: true, removable: true }
    ]
  },
  {
    module: 'REPORT_NFCE',
    colunas: [
      { field: 'ide_nnf', active: true, removable: true },
      { field: 'ide_serie', active: true, removable: true },
      { field: 'dest_xnome', active: true, removable: false },
      { field: 'dest_cpf', active: true, removable: true },
      { field: 'chave', active: true, removable: true },
      { field: 'total_icmstot_vnf', active: true, removable: true },
      { field: 'ide_dhemi', active: true, removable: true },
      { field: 'status', active: true, removable: true }
    ]
  }
] as IColunasSettingsUser[];
